module.exports = __webpack_public_path__ + "static/media/5.acf4a252.JPG";